function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "lefAtivo 4uva");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Camada_2",
  "data-name": "Camada 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "_\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M369.62,271.92c-.65,0-1.32,0-2-.09a21.33,21.33,0,0,1-19.28-23.16h0a231.13,231.13,0,0,0-9.27-78.42C323.36,119,290.57,86.62,241.64,73.94a21.33,21.33,0,0,1,10.7-41.29c63.84,16.53,108.09,60.29,128,126.52,14.48,48.28,10.7,91.56,10.54,93.38A21.34,21.34,0,0,1,369.62,271.92Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M412.31,196.68a233.7,233.7,0,0,1-43-3.78l-16.57-3.39-.47-16.91c-.1-3.79-1.92-93.39,53.82-140.16C438.09,5.63,480.55,0,510.55,0A233.52,233.52,0,0,1,553.5,3.78l16.58,3.39.46,16.91c.11,3.79,1.92,93.39-53.81,140.16C484.77,191.05,442.31,196.68,412.31,196.68Zm-16.39-43.31c4.8.38,10.36.65,16.39.65,22.91,0,54.87-3.89,77-22.46,27.24-22.86,35.27-64.43,37.63-88.25-4.81-.38-10.36-.65-16.39-.65-22.91,0-54.88,3.9-77,22.46C406.31,88,398.27,129.55,395.92,153.37Z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "480.7 452.16 487.8 439.59 494.89 452.16 480.7 452.16"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "245.11 452.16 252.2 439.59 259.29 452.16 245.11 452.16"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "362.91 510.1 370 522.66 377.09 510.1 362.91 510.1"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "362.91 657.76 370 645.19 377.09 657.76 362.91 657.76"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.4,514.11C60.29,514.11,0,453.82,0,379.71S60.29,245.3,134.4,245.3s134.41,60.29,134.41,134.41S208.52,514.11,134.4,514.11Zm0-221.41a87,87,0,1,0,87,87A87.1,87.1,0,0,0,134.4,292.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M370,514.11c-74.11,0-134.4-60.29-134.4-134.4S295.89,245.3,370,245.3s134.4,60.29,134.4,134.41S444.11,514.11,370,514.11Zm0-221.41a87,87,0,1,0,87,87A87.11,87.11,0,0,0,370,292.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M605.59,514.11c-74.11,0-134.4-60.29-134.4-134.4S531.48,245.3,605.59,245.3,740,305.59,740,379.71,679.71,514.11,605.59,514.11Zm0-221.41a87,87,0,1,0,87,87A87.1,87.1,0,0,0,605.59,292.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M252.2,719.4c-74.11,0-134.4-60.3-134.4-134.41s60.29-134.4,134.4-134.4S386.61,510.88,386.61,585,326.31,719.4,252.2,719.4Zm0-221.42a87,87,0,1,0,87,87A87.12,87.12,0,0,0,252.2,498Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M487.8,719.4c-74.12,0-134.41-60.3-134.41-134.41s60.29-134.4,134.41-134.4S622.2,510.88,622.2,585,561.91,719.4,487.8,719.4Zm0-221.42a87,87,0,1,0,87,87A87.11,87.11,0,0,0,487.8,498Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M370,924.73c-74.11,0-134.4-60.3-134.4-134.41s60.29-134.4,134.4-134.4,134.4,60.29,134.4,134.4S444.11,924.73,370,924.73Zm0-221.41a87,87,0,1,0,87,87A87.1,87.1,0,0,0,370,703.32Z"
})));

var SvgUva = function SvgUva(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 740 924.73",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUva, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/uva.4afc9c98.svg";
export { ForwardRef as ReactComponent };